<!-- src/components/ConfirmRegistration.vue -->

<template>
  <div class="full-screen-background">
  <v-container class="pa-4 fill-height">
    <v-row align="center" justify="center">

      <!-- Imagem esquerda -->
      <v-col cols="6" sm="4" md="2" class="text-center">
        <v-img
          :src="ninjaImg"
          alt="Ninja"
          contain
          class="login-img"
        />
      </v-col>

      <!-- Coluna do formulário -->
      <v-col cols="12" sm="8" md="4">
        <div class="text-center">
          <h1 class="mb-4">Confirme seu cadastro</h1>
        </div>

        <!-- ALERTAS -->
        <v-alert
          v-if="alert.message"
          :type="alert.type"
          dense
          dismissible
          class="mb-4"
          @input="alert.message = ''"
        >
          {{ alert.message }}
        </v-alert>

        <v-form @submit.prevent="onConfirm">
          <!-- E-mail -->
          <v-text-field
            v-model="email"
            label="E-mail"
            type="email"
            :rules="[
              v => !!v || 'E-mail é obrigatório',
              v => emailValid || 'E-mail inválido'
            ]"
            required
          />
          <!-- Código de Confirmação -->
          <v-text-field
            v-model="code"
            label="Código de Confirmação"
            :rules="[v => !!v || 'Código é obrigatório']"
            required
          />

          <!-- Botão centralizado -->
          <div class="text-center">
            <v-btn
              type="submit"
              class="mt-4"
              color="red"
              :disabled="!isFormValid"
            >
              Confirmar Cadastro
            </v-btn>
          </div>
        </v-form>
        <br>
        <v-label class="mb-4 text-center">Foi enviado um email no seu endereço, caso não encontre no <br> inbox, verifique sua caixa de spam</v-label>
      </v-col>

  
      <!-- Imagem direita -->
      <v-col cols="6" sm="4" md="2" class="text-center">
        <v-img
          :src="ninjaImg"
          alt="Ninja"
          contain
          class="login-img"
        />
      </v-col>

    </v-row>
  </v-container>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { confirmRegistration } from '../services/api'
import ninjaImg from '@/assets/zerkerConfirm.png'

const router = useRouter()
const route = useRoute()

const email = ref(route.query.email || '')
const code = ref('')

// Controle de alerts
const alert = ref({ type: '', message: '' })

const emailValid = computed(() =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)
)

const isFormValid = computed(() =>
  emailValid.value && code.value.trim().length > 0
)

async function onConfirm() {
  alert.value.message = ''
  try {
    await confirmRegistration(email.value, code.value)
    alert.value = {
      type: 'success',
      message: 'Conta confirmada com sucesso! Agora faça login.'
    }
    router.push({ name: 'Login' })
  } catch (err) {
    alert.value = { type: 'error', message: err.message }
  }
}
</script>

<style scoped>
.login-img {
  margin-bottom:55%;
  margin-left: -30%;
  display: block;
  width: 150%;      /* faz a imagem “sobrar” um pouco além do col */
  max-width: 800px; /* mas nunca maior que 800px */
  height: auto;     /* preserva proporção */
}
 .full-screen-background {
  background-image: url('@/assets/background/cassino/cassinoz.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}
</style>
